module.exports = __webpack_public_path__ + "img/9788959523368.10fb9f27.jpg";